import { Flex, Text, IconButton } from '@chakra-ui/react'
import { ChevronLeftIcon, ChevronRightIcon } from '@chakra-ui/icons'
import { useMemo } from 'react'

interface MonthCarouselProps {
  selectedMonth: Date
  onMonthChange: (date: Date) => void
}

const MonthCarousel: React.FC<MonthCarouselProps> = ({
  selectedMonth,
  onMonthChange,
}) => {
  const months = useMemo(() => {
    const today = new Date()
    const currentMonth = today.getMonth()
    const currentYear = today.getFullYear()
    const result = []

    // Generate 12 months starting from current month
    for (let i = 0; i < 12; i++) {
      const month = (currentMonth + i) % 12
      const year = currentYear + Math.floor((currentMonth + i) / 12)
      const date = new Date(year, month, 1)
      result.push(date)
    }

    return result
  }, [])

  const displayText = selectedMonth.toLocaleString('default', {
    month: 'long',
  })

  const currentMonthIndex = months.findIndex(
    (month) =>
      month.getMonth() === selectedMonth.getMonth() &&
      month.getFullYear() === selectedMonth.getFullYear()
  )

  const isOutofRange = currentMonthIndex < 0
  const canGoBack = !isOutofRange && currentMonthIndex > 0
  const canGoForward = !isOutofRange && currentMonthIndex < months.length - 1

  return (
    <Flex align="center" justify="center" mb={4}>
      <IconButton
        variant="ghost"
        aria-label="Previous month"
        icon={<ChevronLeftIcon />}
        onClick={() => {
          if (canGoBack) {
            const previousMonth = months[currentMonthIndex - 1]
            onMonthChange(previousMonth)
          }
        }}
        isDisabled={!canGoBack}
      />
      <Text mx={4} fontSize="lg" fontWeight="bold" mb="0">
        {displayText}
      </Text>
      <IconButton
        variant="ghost"
        aria-label="Next month"
        icon={<ChevronRightIcon />}
        onClick={() => {
          if (canGoForward) {
            const nextMonth = months[currentMonthIndex + 1]
            onMonthChange(nextMonth)
          }
        }}
        isDisabled={!canGoForward}
      />
    </Flex>
  )
}

export default MonthCarousel
